<!--
  The two variants repeat the mat-select rather than share it through an ng-template: mat-form-field
  finds its control with a content query, which does not reach into a template declared outside it,
  so an ngTemplateOutlet here would leave the form field without a control.
-->
@if (variant === 'form-field') {
  <mat-form-field class="cfi-searchable-select-field">
    <mat-select
      [id]="controlId"
      [value]="value"
      [disabled]="isDisabled"
      [placeholder]="placeholder"
      [panelClass]="['cfi-searchable-select-panel', panelClass]"
      [attr.aria-labelledby]="ariaLabelledBy"
      [attr.aria-describedby]="ariaDescribedBy"
      [attr.data-pw]="testPrefix ? testPrefix + testSeparator + 'select' : null"
      [attr.data-qa]="testPrefix ? testPrefix + testSeparator + 'select' : null"
      (selectionChange)="onSelectionChange($event.value)"
      (openedChange)="$event || markTouched()">
      <mat-option>
        <ngx-mat-select-search
          [formControl]="searchControl"
          [placeholderLabel]="searchPlaceholder"
          [preventHomeEndKeyPropagation]="true"
          [attr.data-pw]="testPrefix ? testPrefix + testSeparator + 'search' : null"
          [attr.data-qa]="testPrefix ? testPrefix + testSeparator + 'search' : null">
          <span ngxMatSelectNoEntriesFound>{{ noEntriesLabel }}</span>
        </ngx-mat-select-search>
      </mat-option>

      @for (option of visibleOptions; track trackByValue($index, option)) {
        <mat-option
          [value]="option.value"
          [attr.data-pw]="testPrefix ? testPrefix + testSeparator + 'option' + testSeparator + option.value : null"
          [attr.data-qa]="testPrefix ? testPrefix + testSeparator + 'option' + testSeparator + option.value : null">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
} @else {
  <mat-select
    [id]="controlId"
    [value]="value"
    [disabled]="isDisabled"
    [placeholder]="placeholder"
    [panelClass]="['cfi-searchable-select-panel', panelClass]"
    [attr.aria-labelledby]="ariaLabelledBy"
    [attr.aria-describedby]="ariaDescribedBy"
    [attr.data-pw]="testPrefix ? testPrefix + testSeparator + 'select' : null"
    [attr.data-qa]="testPrefix ? testPrefix + testSeparator + 'select' : null"
    (selectionChange)="onSelectionChange($event.value)"
    (openedChange)="$event || markTouched()">
    <mat-option>
      <ngx-mat-select-search
        [formControl]="searchControl"
        [placeholderLabel]="searchPlaceholder"
        [preventHomeEndKeyPropagation]="true"
        [attr.data-pw]="testPrefix ? testPrefix + testSeparator + 'search' : null"
        [attr.data-qa]="testPrefix ? testPrefix + testSeparator + 'search' : null">
        <span ngxMatSelectNoEntriesFound>{{ noEntriesLabel }}</span>
      </ngx-mat-select-search>
    </mat-option>

    @for (option of visibleOptions; track trackByValue($index, option)) {
      <mat-option
        [value]="option.value"
        [attr.data-pw]="testPrefix ? testPrefix + testSeparator + 'option' + testSeparator + option.value : null"
        [attr.data-qa]="testPrefix ? testPrefix + testSeparator + 'option' + testSeparator + option.value : null">
        {{ option.label }}
      </mat-option>
    }
  </mat-select>
}
